define(function(require, exports, module) {
    'use strict';

    var i18n = require('i18n');
    var validationHelpers = require('modules/user/user.validation.helpers');
    var userValidationConfig = require('modules/user/user.validation.config');

    module.exports = function() {
        const usrCnfg = userValidationConfig();

        usrCnfg.phoneWithArea = {
            fn: {
                fn: function($inputs) {
                    return validationHelpers.validatePhoneNumber.call(this, true, $inputs);
                },
                message: i18n.t('playtech.mobile.system.user.tooltip.phoneWithArea.fn')
            }
        };

        return usrCnfg;
    };
});
